import { useMemo } from 'react';
import { useEventPlaces } from '@shared/utils/eventPlace';
import { useAccommodationsContext } from '../context/useAccommodationsContext';

/**
 * Hook to get the auto populated accommodations and if it is the first time auto population.
 */
export const useAutoPopulatedAccommodations = () => {
  const { venueInfo } = useEventPlaces();
  const { accommodationsData, loadingData } = useAccommodationsContext();

  const hasAccommodations = !!accommodationsData?.accommodationPlacesV2?.length;

  const { autoPopulatedAccommodations, isFirstTimeAutoPopulation } = useMemo(() => {
    const places = accommodationsData?.accommodationPlacesV2 ?? [];

    const result = places.reduce(
      (acc, place) => {
        if (place.autoSuggestionRecommendation) {
          acc.autoPopulatedAccommodations.push(place);
          if (place.autoSuggestionRecommendation.venueGooglePlaceId === venueInfo.googlePlaceId) {
            acc.matchingCount++;
          } else {
            acc.nonMatchingCount++;
          }
        }
        return acc;
      },
      { autoPopulatedAccommodations: [] as typeof places, matchingCount: 0, nonMatchingCount: 0 },
    );

    return {
      autoPopulatedAccommodations: result.autoPopulatedAccommodations as ReadonlyArray<(typeof places)[number]>,
      isFirstTimeAutoPopulation: result.matchingCount > 0 && result.nonMatchingCount === 0,
    };
  }, [accommodationsData?.accommodationPlacesV2, venueInfo.googlePlaceId]);

  return { loadingData, hasAccommodations, autoPopulatedAccommodations, isFirstTimeAutoPopulation };
};
